import { render, staticRenderFns } from "./GestioneAziende.vue?vue&type=template&id=5618a9c3&"
import script from "./GestioneAziende.vue?vue&type=script&lang=js&"
export * from "./GestioneAziende.vue?vue&type=script&lang=js&"
import style0 from "./GestioneAziende.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports